export const CategoryRoute = {
  CATEGORIES: 'categories',
  CATEGORIESOVERVIEW: 'categoriesoverview',
  CATEGORYOVERVIEW: 'categoryoverview',
};

export const CategoryPathName = {
  CATEGORIES: 'categories',
  CATEGORIESDATAVIEWS: 'categoriesdataviews',
  CATEGORIESOVERVIEW: 'categoriesoverview',
  CATEGORYOVERVIEW: 'categoryoverview',
  CATEGORIESFORM_NEW: 'categoriesForm:new',
  CATEGORIESFORM: 'categoriesForm',
  CATEGORIESMETRIC: 'categoriesmetric',
  CATEGORIESDRILLDOWN: 'categoriesdrilldown',
};

export const CATEGORY_SAVE_EVENT = 'CategorySaveEvent';

// AI Foundation agent that operates on channels (categories). Sent as the
// /ai/chat target_agent_key to bind the assistant to this single agent (D52).
export const AI_OPERATOR_AGENT_CHANNEL_KEY = 'channel_operator_agent';

// Ref name of the channel ListView inside CategoryList, used to reload the
// list after an AI action.
export const CHANNEL_LIST_REF = 'categoryListView';

// §14.1 page-context envelope values for the channel chat surface.
export const CategoryAiPageContext = {
  SCHEMA_VERSION: '1',
  ROUTE_KEY_FORM: 'channel.form',
  ROUTE_KEY_LIST: 'channel.list',
  ROUTE_KEY_METRIC_FORM: 'channel.metric_form',
  ROUTE_KEY_DATAVIEW_FORM: 'channel.dataview_form',
  ENTITY_TYPE: 'category',
};

export const Constants = {
  ID: 'id',
  NAME: 'name',
  CATEGORY_METRICS: 'category_metrics',
  PARENT_NAME: 'parent_name',
  LABEL: 'label',
  FIELD: 'field',
  MODEL: 'model',
  EXTENDED_ID: 'extended_id',
  DATASOURCE_PRIMARY_KEY: 'id',
  DATASOURCE_VALUE_KEY: 'name',
  CATEGORY_METRIC_PRIMARY_KEY: 'category_metric_id',
  CATEGORY_METRIC_VALUE_KEY: 'name',
};
